import React from 'react';
import { ResearchIntro } from '../components/research/ResearchIntro';
import { ResearchSkp } from '../components/research/ResearchSkp';
import { ResearchPriorities } from '../components/research/ResearchPriorities';
import { ResearchMap } from '../components/research/ResearchMap';
import { ResearchConcepts } from '../components/research/ResearchConcepts';
import { CognarchicFoundation } from '../components/research/CognarchicFoundation';
import { OperationalSystems } from '../components/research/OperationalSystems';
import { ResearchTesting } from '../components/research/ResearchTesting';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
export function ResearchPage() {
  return <>
      <ResearchIntro data-id="element-3290" data-mp="30j7mun7x706v" />
      <ResearchMap data-id="element-3291" data-mp="30jqth7s4e25l" />
      <ResearchSkp data-id="element-3292" data-mp="30k8wcn9afemh" />
      <ResearchPriorities data-id="element-3293" data-mp="13q5u4fjpzew7" />
      <ResearchConcepts data-id="element-3294" data-mp="13okvoeuabbt2" />
      <RelatedInitiative name="Cognocracy" status="Concept Proposal" body="A civic project that draws on this research, including the NCJI assessment model and its open questions. Its associated government solution is NCDS." href="/projects/cognocracy" data-id="element-3295" data-mp="13ouoea6prx2g" />
      <section aria-labelledby="related-governance" className="bg-white border-t border-line pt-20 lg:pt-24" data-id="element-3296" data-mp="bxoe82ejucu6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-3297" data-mp="3u42rdz4zuiri">
          <h2 id="related-governance" className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-3298" data-mp="2xjfegnf8mrm">
            Related governance research
          </h2>
          <p className="lg:col-span-7 text-lg text-ink-muted leading-relaxed" data-id="element-3299" data-mp="guetinij54ej">
            The sections below explore how SyNeural’s architecture could relate
            to the Cognarchic State, a separate governance proposal. They are
            research material, not part of SyNeural’s current products or
            demos.
          </p>
        </div>
      </section>
      <CognarchicFoundation data-id="element-3300" data-mp="1o6ke11y2nw74" />
      <OperationalSystems data-id="element-3301" data-mp="1o5swgv1b7yzu" />
      <ResearchTesting data-id="element-3302" data-mp="1o62lafamc03y" />
    </>;
}